<template>
    <div class="tooltip-position-assignment">
        <span v-if="group && position"><strong>{{ group.name }}</strong> - {{ position.name }}</span>
        <div class="tooltip-specifications">
            <div v-for="positionDeployment of positionDeployments" :key="'positionAssignment|' + positionDeployment.id">
                {{ formatTime(positionDeployment.beginTime) }} - {{ formatTime(positionDeployment.endTime) }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {PositionAssignmentSetGroup, PositionAssignmentSetGroupPosition, PositionAssignmentSetGroupPositionDeployment} from '@cquential/api';
    import Dates from '@cquential/date-utils';

    @Component
    export default class TooltipPositionAssignment extends Vue {
        @Prop({type: Number, required: true}) public positionId!: number;
        @Prop({required: true}) public positionGroups!: PositionAssignmentSetGroup[];
        @Prop({required: true}) public positionDeployments!: PositionAssignmentSetGroupPositionDeployment[];

        public get group(): PositionAssignmentSetGroup | null {
            if (!this.positionGroups) {
                return null;
            }

            for (const group of this.positionGroups) {
                if ((group.positions ?? []).some((position: PositionAssignmentSetGroupPosition): boolean => position.id == this.positionId)) {
                    return group;
                }
            }

            return null;
        }

        public get position(): PositionAssignmentSetGroupPosition | null {
            return this.group?.positions?.find((position: PositionAssignmentSetGroupPosition): boolean => position.id == this.positionId) ?? null;
        }

        public formatTime(time: string): string {
            const date: Date = Dates.Utils.setTimeOnDate(new Date(), time);

            return Dates.Formatter.formatTime(date);
        }
    }
</script>

<style lang="scss" scoped>
    .tooltip-specifications {
        padding-left: 3px;
        border-left: 2px solid #ccc;
        margin-left: 3px;
    }
</style>
